import React, { useState } from "react";

const questions = [
  {
    id: 1,
    text: "1. Đầu tuần, sếp thảy cho một project mới toanh và siêu gấp. Phản ứng đầu tiên của bạn là:",
    options: {
      A: "'Mục tiêu cuối cùng là gì sếp? Deadline thứ mấy? Để em chốt.'",
      B: "'Kèo này thơm! Team mình ai làm chung vụ này vậy sếp?'",
      C: "'Chà, gấp thế này thì quy trình cũ có bị xáo trộn không sếp?'",
      D: "'Sếp cho em xin bản brief chi tiết và số liệu ngân sách để em đọc trước nhé.'"
    }
  },
  {
    id: 2,
    text: "2. Phong cách chat Zalo công việc của bạn thường trông như thế nào?",
    options: {
      A: "Ngắn gọn, gạch đầu dòng, thỉnh báo cộc lốc. Không icon.",
      B: "Thả tim, thả haha liên tục, dùng rất nhiều sticker và dấu chấm than!!!",
      C: "Dạ vâng cẩn thận, nhắn câu cú đàng hoàng, sợ mếch lòng người đọc.",
      D: "Gửi kèm file Excel, cap màn hình có khoanh đỏ chót để minh chứng."
    }
  },
  {
    id: 3,
    text: "3. Đang họp team hăng say thì xảy ra cãi vã lớn. Bạn sẽ làm gì?",
    options: {
      A: "Đập bàn (hoặc nói to): 'Lan man quá, chốt lại giải pháp là gì?'",
      B: "Pha trò một chút để hạ nhiệt, rồi kéo mọi người ra ngoài uống nước.",
      C: "Ngồi im, thấy căng thẳng quá chỉ muốn cuộc họp kết thúc sớm cho êm đẹp.",
      D: "Nhắc lại các quy định và bằng chứng logic để phân xử đúng sai rạch ròi."
    }
  },
  {
    id: 4,
    text: "4. Điều gì khiến bạn 'sôi máu' nhất ở chốn công sở?",
    options: {
      A: "Mọi người làm việc lề mề, ra quyết định quá chậm chạp.",
      B: "Bị ngó lơ, không ai nghe ý tưởng của mình hoặc môi trường quá tẻ nhạt.",
      C: "Thay đổi kế hoạch xoành xoạch vào phút chót làm không kịp trở tay.",
      D: "Làm việc cẩu thả, sai số liệu, không tuân thủ quy trình chuẩn."
    }
  },
  {
    id: 5,
    text: "5. Bàn làm việc của bạn ở công ty trông như thế nào?",
    options: {
      A: "Hơi lộn xộn, chỉ cần máy tính hoạt động nhanh là được, đang bận cày số.",
      B: "Đầy đồ trang trí, hình ảnh ăn chơi, kẹo bánh, cốc cafe sặc sỡ.",
      C: "Gọn gàng, có chậu cây nhỏ, hình gia đình, mang lại cảm giác bình yên.",
      D: "Ngăn nắp cực kỳ, giấy tờ xếp theo tệp, bút để đúng chỗ, dán note chi chít."
    }
  },
  {
    id: 6,
    text: "6. Khi phải chỉ việc cho một đứa lính mới (newbie), bạn sẽ:",
    options: {
      A: "Chỉ mục tiêu, quăng nó vào làm thử luôn, sai đâu sửa đó cho lẹ.",
      B: "Dẫn đi dạo một vòng công ty chào hỏi, kể chuyện vui về team trước.",
      C: "Ngồi cạnh cầm tay chỉ việc từ từ, kiên nhẫn để nó không bị ngợp.",
      D: "Gửi cho nó một nùi file SOP (quy trình chuẩn) bắt đọc xong mới được làm."
    }
  },
  {
    id: 7,
    text: "7. Trong các buổi đi quẩy (team building), bạn thường sắm vai gì?",
    options: {
      A: "Người cầm trịch, đốc thúc anh em chơi game phải thắng bằng được.",
      B: "Quản trò, cầm mic hát hò, quẩy nhiệt tình nhất hội.",
      C: "Hậu cần âm thầm, đứng nướng thịt, lo nước nôi cho anh em.",
      D: "Người lên file Excel tính toán chi phí, lịch trình chi tiết từng phút."
    }
  },
  {
    id: 8,
    text: "8. Cách bạn đưa ra một quyết định quan trọng trong công việc:",
    options: {
      A: "Tin vào trực giác và kinh nghiệm, chốt nhanh để còn làm việc khác.",
      B: "Hỏi ý kiến xem anh em xung quanh cảm thấy thế nào, vui thì làm.",
      C: "Đắn đo một chút, cân nhắc xem quyết định này có ảnh hưởng ai trong team không.",
      D: "Phân tích rủi ro, kẻ bảng so sánh thiệt hơn, có số liệu mới dám chốt."
    }
  },
  {
    id: 9,
    text: "9. Nhận được một email khen ngợi từ sếp tổng, bạn phản ứng sao?",
    options: {
      A: "Thấy bình thường vì đó là kết quả xứng đáng với công sức mình bỏ ra.",
      B: "Sướng rơn! Cap màn hình khoe ngay vào group chat hội chị em bạn dì.",
      C: "Vui vẻ nhưng âm thầm forward thư cảm ơn lại cho cả team vì mọi người đã giúp đỡ.",
      D: "Lưu lại cẩn thận vào folder 'Thành tích' để cuối năm làm bằng chứng review lương."
    }
  },
  {
    id: 10,
    text: "10. Đồng nghiệp nhờ bạn check hộ một file báo cáo. Bạn sẽ:",
    options: {
      A: "Lướt nhanh xem kết quả cuối cùng có đạt KPI không.",
      B: "Khen format đẹp trước, rồi mới chỉ ra vài chỗ sai nhỏ nhẹ nhàng.",
      C: "Sửa hộ họ luôn mấy lỗi lặt vặt để họ đỡ vất vả.",
      D: "Soi từng dấu phẩy, check lại công thức hàm Excel xem có lỗi không."
    }
  },
  {
    id: 11,
    text: "11. Bạn thích một người sếp như thế nào?",
    options: {
      A: "Giao quyền tự quyết, chỉ quan tâm kết quả, không quản lý vi mô (micromanage).",
      B: "Truyền cảm hứng, cởi mở, hay tổ chức ăn chơi nhảy múa.",
      C: "Điềm tĩnh, hỗ trợ nhân viên lúc khó khăn, không hay nổi nóng.",
      D: "Đầu óc logic, giao việc có kế hoạch rõ ràng, công tư phân minh."
    }
  },
  {
    id: 12,
    text: "12. Chiều thứ Sáu rảnh rỗi, chưa tới giờ về, bạn thường làm gì?",
    options: {
      A: "Ngồi lên kế hoạch công việc cho tuần sau luôn để khỏi cập rập.",
      B: "Lượn lờ các ban bệ buôn dưa lê, chém gió xả stress.",
      C: "Tranh thủ dọn dẹp lại chỗ ngồi, hỏi xem có ai cần giúp gì không.",
      D: "Rà soát lại toàn bộ công việc trong tuần xem có sót email hay số liệu nào không."
    }
  }
];

const resultsData = {
  A: { title: "NHÓM D (DRIVER) - NGƯỜI LÁI TÀU QUYẾT ĐOÁN 🚀", desc: "Đặc điểm nhận dạng: Làm việc tốc độ bàn thờ, cực kỳ thẳng thắn và hướng tới kết quả. Bạn là cỗ máy ủi mọi deadline. Tuy nhiên, đôi khi hơi nóng tính và làm anh em tổn thương vì lời nói cộc lốc. Lời khuyên: Chậm lại 1 nhịp, rào trước đón sau một tí để anh em đỡ sốc nhé!" },
  B: { title: "NHÓM i (INSPIRER) - CÂY HÀI TRUYỀN CẢM HỨNG 🌟", desc: "Đặc điểm nhận dạng: Mỏ khoét của phòng, đi đến đâu vui đến đó. Bạn cực kỳ sáng tạo và giỏi giao tiếp. Nhược điểm là hay quên, làm việc tùy hứng và ghét tiểu tiết. Lời khuyên: Vui thôi đừng vui quá, nhớ note lại các đầu việc quan trọng kẻo trễ deadline sấp mặt nha!" },
  C: { title: "NHÓM S (SUPPORTER) - THIÊN THẦN HÒA BÌNH 🕊️", desc: "Đặc điểm nhận dạng: Hiền khô, bao dung và luôn vì tập thể. Team có bạn như có một người mẹ chăm lo hậu cần. Bạn rất ngại va chạm và sợ sự thay đổi đột ngột. Lời khuyên: Hãy mạnh dạn nói 'KHÔNG' khi bị nhờ vả quá mức, và tập lên tiếng bảo vệ ý kiến của mình hơn nhé." },
  D: { title: "NHÓM C (CHECKER) - BỘ NÃO LOGIC & KỶ LUẬT 🧠", desc: "Đặc điểm nhận dạng: 'Thánh soi' của văn phòng. Bạn làm việc cực kỳ cẩn thận, có nguyên tắc và số liệu rõ ràng. Rất hiếm khi bạn mắc lỗi. Tuy nhiên, bạn dễ bị cho là cứng nhắc và bảo thủ. Lời khuyên: Đôi khi 'hoàn thành' quan trọng hơn 'hoàn hảo', linh hoạt lên một xíu để dự án trôi nhanh hơn nhé." }
};

export default function DiSCAssessment() {
  const [answers, setAnswers] = useState({});
  const [result, setResult] = useState(null);

  const handleSelect = (questionId, optionKey) => {
    setAnswers({ ...answers, [questionId]: optionKey });
  };

  const calculateResult = () => {
    if (Object.keys(answers).length < questions.length) {
      alert("Ê khoan, check lại xem còn sót câu nào chưa click không bồ ơi!");
      return;
    }

    const counts = { A: 0, B: 0, C: 0, D: 0 };
    Object.values(answers).forEach((ans) => {
      counts[ans]++;
    });

    let highestScore = 0;
    let winningStyle = "A";

    for (const [key, value] of Object.entries(counts)) {
      if (value > highestScore) {
        highestScore = value;
        winningStyle = key;
      }
    }

    setResult(resultsData[winningStyle]);
    window.scrollTo({ top: 0, behavior: "smooth" });
  };

  return (
    <div style={{ maxWidth: "600px", margin: "0 auto", padding: "20px", fontFamily: "sans-serif" }}>
      <h1 style={{ textAlign: "center", color: "#333" }}>Bạn Là 'Hệ' Nào Chốn Công Sở? (DiSC Test) 🕵️‍♂️</h1>
      
      <div style={{ backgroundColor: "#e2e3e5", padding: "20px", borderRadius: "8px", borderLeft: "5px solid #6c757d", marginBottom: "30px", color: "#383d41" }}>
        <p style={{ margin: "0 0 10px 0", fontWeight: "bold", fontSize: "16px" }}>💡 Bạn có biết?</p>
        <p style={{ margin: "0", lineHeight: "1.5", fontSize: "15px" }}>
          DiSC giống như "hệ điều hành" của mỗi người chốn công sở. Hiểu được mình và đồng nghiệp thuộc nhóm nào sẽ giúp anh em né được những pha "choảng" nhau sứt đầu mẻ trán trong group Zalo hay những lần họp hành căng thẳng. Đặc biệt là khi kết hợp với văn hóa làm việc đặc trưng của miền Nam - Bắc!
        </p>
        
        <div style={{ marginTop: "20px", padding: "15px", backgroundColor: "#ffffff", borderRadius: "8px", border: "1px dashed #6c757d" }}>
          <p style={{ margin: "0 0 10px 0", fontWeight: "bold", fontSize: "15px", color: "#333" }}>📚 Lộ Trình "Tu Luyện" DiSC Cho Team:</p>
          <ul style={{ margin: "0", paddingLeft: "20px", fontSize: "15px", lineHeight: "1.8", color: "#333" }}>
            <li>
              <strong>Bước 1:</strong> Xem Video tóm tắt "chuẩn cơm mẹ nấu" <a href="https://notebooklm.google.com/notebook/907c6d8f-a754-4258-a081-2395ce4ef770?artifactId=108054f4-7fee-4a7f-9db9-2216d45ba944" target="_blank" rel="noreferrer" style={{ color: "#007BFF", textDecoration: "none", fontWeight: "bold" }}>[Xem Tại Đây]</a>
            </li>
            <li>
              <strong>Bước 2:</strong> Nghe Podcast chém gió dạo về DiSC x Văn hóa vùng miền <a href="https://notebooklm.google.com/notebook/907c6d8f-a754-4258-a081-2395ce4ef770?artifactId=c2a794c4-d7cd-4d19-8768-6a353b8eb3cb" target="_blank" rel="noreferrer" style={{ color: "#007BFF", textDecoration: "none", fontWeight: "bold" }}>[Nghe Tại Đây]</a>
            </li>
            <li>
              <strong>Bước 3:</strong> Làm bài Trắc nghiệm bản thân (ngay bên dưới 👇)
            </li>
            <li>
              <strong>Bước 4:</strong> Làm bài Kiểm tra kiến thức sinh tồn <a href="/kiem-tra-disc" style={{ color: "#007BFF", textDecoration: "none", fontWeight: "bold" }}>[Test Tại Đây]</a>
            </li>
          </ul>
        </div>
      </div>

      {!result ? (
        <div>
          {questions.map((q) => (
            <div key={q.id} style={{ marginBottom: "25px", padding: "15px", border: "1px solid #ddd", borderRadius: "8px", backgroundColor: "#f9f9f9" }}>
              <p style={{ fontWeight: "bold", marginTop: "0" }}>{q.text}</p>
              <div style={{ display: "flex", flexDirection: "column", gap: "10px" }}>
                {Object.entries(q.options).map(([key, text]) => (
                  <label key={key} style={{ cursor: "pointer", display: "flex", alignItems: "center", gap: "10px", padding: "5px" }}>
                    <input
                      type="radio"
                      name={`question-${q.id}`}
                      value={key}
                      checked={answers[q.id] === key}
                      onChange={() => handleSelect(q.id, key)}
                      style={{ width: "20px", height: "20px" }}
                    />
                    {text}
                  </label>
                ))}
              </div>
            </div>
          ))}

          <button 
            onClick={calculateResult} 
            style={{ width: "100%", padding: "15px", fontSize: "18px", backgroundColor: "#17a2b8", color: "white", border: "none", borderRadius: "8px", cursor: "pointer", fontWeight: "bold" }}
          >
            Chốt Đơn & Xem Kết Quả!
          </button>
        </div>
      ) : (
        <div style={{ textAlign: "center", padding: "30px", border: "2px solid #17a2b8", borderRadius: "10px", backgroundColor: "#e0f2f1" }}>
          <h2>Kết Quả Của Bạn:</h2>
          <h1 style={{ color: "#00695c", fontSize: "28px" }}>{result.title}</h1>
          <p style={{ fontSize: "18px", lineHeight: "1.6" }}>{result.desc}</p>
          <button 
            onClick={() => { setResult(null); setAnswers({}); }} 
            style={{ marginTop: "20px", padding: "10px 20px", backgroundColor: "#333", color: "white", border: "none", borderRadius: "5px", cursor: "pointer" }}
          >
            Làm lại bài test
          </button>
          <p style={{ marginTop: "20px", fontWeight: "bold", color: "#d9534f" }}>
            👉 Đừng quên chia sẻ kết quả này với đồng nghiệp để anh em biết đường làm việc chung nhé!
          </p>
        </div>
      )}
    </div>
  );
}